module.exports = __webpack_public_path__ + "static/media/Logo1.56c6eda8.svg";